import { render, staticRenderFns } from "./EWMerchantRegistrationRejectedList.vue?vue&type=template&id=73ed809c&"
import script from "./EWMerchantRegistrationRejectedList.vue?vue&type=script&lang=js&"
export * from "./EWMerchantRegistrationRejectedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports